"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const store = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-store` : '') + (description ? ` desc-store` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-store"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-store"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.25 2A.75.75 0 0 1 1 1.25h22a.75.75 0 0 1 0 1.5h-.25V21.5c0 .69-.56 1.25-1.25 1.25h-19c-.69 0-1.25-.56-1.25-1.25V2.75H1A.75.75 0 0 1 .25 2Zm2.5.75h18.5v13.5h-3.5v-3.5h.495c.895 0 1.5-.914 1.15-1.738l-2.12-5a1.25 1.25 0 0 0-1.151-.762H7.876c-.501 0-.954.3-1.15.762l-2.121 5a1.25 1.25 0 0 0 1.15 1.738h.495v3.5h-3.5V2.75Zm0 15v3.5h3.5v-3.5h-3.5Zm15 0v3.5h3.5v-3.5h-3.5Zm-1.5-5h-3.5v8.5h3.5v-8.5Zm-5 0h-3.5v8.5h3.5v-8.5Zm-3.75-1.5h10.367l-1.909-4.5H8.042l-1.91 4.5H7.5Z",
    fill: "inherit"
  }));
};
var _default = exports.default = store;